import {NgModule} from '@angular/core';
import {DecarbonizationScreenComponent} from './decarbonization-screen.component';
import {SharedModule} from '../shared/shared.module';
import {RouterModule} from '@angular/router';
import {DECARBONIZATION_ROUTES} from './decarbonization.routes';
import {CommonModule} from '@angular/common';
import {FuelTypeService} from './shared/fuel-type.service';
import {VehicleTypeService} from './shared/vehicle-type.service';
import {DecarbonizationTypeListComponent} from './decarbonization-type-list/decarbonization-type-list.component';
import {DecarbonizationFuelTypeListComponent} from './fuel-type-list/decarbonization-fuel-type-list.component';
import {DecarbonizationVehicleTypeListComponent} from './vehicle-type-list/decarbonization-vehicle-type-list.component';

@NgModule({
  imports: [
    RouterModule.forChild(DECARBONIZATION_ROUTES),
    SharedModule,
    CommonModule
  ],
  declarations: [
    DecarbonizationScreenComponent,
    DecarbonizationTypeListComponent,
    DecarbonizationFuelTypeListComponent,
    DecarbonizationVehicleTypeListComponent
  ],
  providers: [
    FuelTypeService,
    VehicleTypeService
  ]
})
export class DecarbonizationModule {
}
